import React from "react";
import ReusableUserHead from "../../directorate/ui/ReusableUserHead";

export default function PastorUserHead({ open }) {
  return <ReusableUserHead open={open} />;
}
